// extracted by mini-css-extract-plugin
export default {"mainWrapper":"style_mainWrapper__IlYK8","refWrapper":"style_refWrapper__HsuVl","sectionWrapper":"style_sectionWrapper__uCEed"};